"use client";

import { enqueueSnackbar } from "notistack";

const SnackbarComponent = ({
  success = false,
  error = false,
  successMessage = "",
  errorMessage = "",
}) => {
  return (
    <>
      {error &&
        enqueueSnackbar(errorMessage, {
          variant: "error",
          autoHideDuration: 4000,
          preventDuplicate: true,
        })}
      {success &&
        enqueueSnackbar(successMessage, {
          variant: "success",
          autoHideDuration: 4000,
          preventDuplicate: true,
        })}
    </>
  );
};

export default SnackbarComponent;
